import produce from "immer";

const INITIAL_STATE = {
  hasMandatoryDocuments: false,
  loading: false,
  documentsList: null,
  documentsLoading: false,
};

const documentRequired = (state = INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case "SET_MANDATORY_DOCUMENTS_STATUS": {
        const { hasMandatoryDocuments } = action.payload;
        draft.hasMandatoryDocuments = hasMandatoryDocuments;
        break;
      }

      case "SET_MANDATORY_DOCUMENTS_LOADING": {
        const { loading } = action.payload;
        draft.loading = loading;
        break;
      }

      case "CHECK_MANDATORY_DOCUMENTS": {
        draft.loading = true;
        break;
      }

      case "FETCH_DOCUMENTS_LIST": {
        draft.documentsLoading = true;
        break;
      }

      case "SET_DOCUMENTS_LIST": {
        const { documentsList } = action.payload;
        draft.documentsList = documentsList;
        draft.documentsLoading = false;
        break;
      }

      default: {
        return draft;
      }
    }
  });
};

export default documentRequired;